import TreeMarkingName from "./TreeMarkingName";
import TreeMarkingLink from "./TreeMarkingLink";

import CuttingName from "../../../../timber/components/cutting/CuttingDetail/CuttingName";
import CuttingLink from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";

import TimberStorageName from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageName";
import TimberStorageLink from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";

import TimberTypeName from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import TimberTypeLink from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TreeMarkingDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="TreeMarking-detail-title"
                    >
                        { label || t`Tree Marking` }: <TreeMarkingName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="TreeMarking-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="TreeMarking-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="cuttingId-label" sx={{ textAlign: "left" }}><Trans>Cutting</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="cuttingId-value" sx={{ textAlign: "left" }}>{ data.cuttingId ? (<CuttingLink id={ data.cuttingId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="storageId-label" sx={{ textAlign: "left" }}><Trans>Timber Storage</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="storageId-value" sx={{ textAlign: "left" }}>{ data.storageId ? (<TimberStorageLink id={ data.storageId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="timberTypeId-label" sx={{ textAlign: "left" }}><Trans>Timber Type</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="timberTypeId-value" sx={{ textAlign: "left" }}>{ data.timberTypeId ? (<TimberTypeLink id={ data.timberTypeId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="volume-label" sx={{ textAlign: "left" }}><Trans>Volume (m&#xB3;)</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="volume-value" sx={{ textAlign: "left" }}>{fixedFormat(data.volume) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default TreeMarkingDetail;
